import Translation from './translation'

export default class Quotation extends Translation
{
    constructor(quotation){
        super()
        this.id             = 0
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar = ''
        this.description_en = ''
        this.description_fa = ''

        this.map(quotation)
        this.init()
    }

    map(quotation){
        if(quotation == undefined) return
        this.id             = quotation.id
        
        this.created_at     = quotation.created_at  
        this.updated_at     = quotation.updated_at  
        this.published_at   = quotation.published_at  

        for (let locale of this.appLocales) {
            this['title_' + locale.code] = quotation.translations[locale.code].title
            this['description_' + locale.code] = quotation.translations[locale.code].description
        }
        this.setLocale(this.appLocales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.appLocales){

            fData.append('translation['+ locale.code +'][title]', this['title_'+ locale.code]);
            fData.append('translation['+ locale.code +'][description]', this['description_'+ locale.code]);
        }

        return fData
    }
}

